export default __webpack_public_path__ + "static/8-8734168da69dab9efe81df169804c80d.jpg";